 export default {
 "doc_title": "Dashboard Documentation",
  "doc_subtitle": "Everything you need to manage your business like a modern e-commerce platform.",

  "profile_setup": "Profile Setup",
  "profile_1": "Basic information (name, email, contact)",
  "profile_2": "Supplier / Restaurant details",
  "profile_3": "Address & location",
  "profile_4": "Bank & payment details",
  "profile_5": "Required document uploads",

  "dashboard_overview": "Dashboard Overview",
  "dash_1": "Revenue – Monthly earnings",
  "dash_2": "Pending Orders – Orders waiting for action",
  "dash_3": "Low Stock – Products to restock",
  "dash_4": "Fulfillment Rate – Order success rate",
  "dash_5": "Sales Trends – Graphical insights",
  "dash_6": "Inventory Health",

  "products": "Products Management",
  "prod_1": "Add products with images & pricing",
  "prod_2": "Edit or disable products anytime",
  "prod_3": "Control stock availability",
  "prod_4": "Assign categories for visibility",

  "orders_delivery": "Orders & Delivery",
  "order_1": "Accept or reject incoming orders",
  "order_2": "View complete order details",
  "order_3": "Track delivery progress",
  "order_4": "Update order status",

  "offers": "Offers & Promotions",
  "offer_1": "Create discounts to attract customers",
  "offer_2": "Use promo codes for campaigns",
  "offer_3": "Run combo offers to increase order value",

  "inventories": "Inventory",
  "inv_1": "Monitor stock in real time",
  "inv_2": "Avoid out-of-stock situations",
  "inv_3": "Improve fulfillment rate",

  "guided_tours": "Guided Tours",
  "tour_1": "Visual walkthroughs for beginners",
  "tour_2": "Highlights important actions",
  "tour_3": "Step-by-step usage help",

  "doc_footer": "Designed to help you grow faster and sell smarter",
 }